import React, { FC, useEffect } from 'react';
import Sheet from '@mui/joy/Sheet';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import deskImage from "../../../../images/desk-image.png";
import ToastMessage from '../../../../common/ToastMessage';
import useScreenWidth from '../../../../store/useScreenWidth';
import useGetTicketsClosedToday from '../../../../store/ReactQueries/dashboards/useGetTicketsClosedToday';
import { useUserStore } from '../../../../store/useUserStore';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { darkModeBackgroud, darkModeBackgroudInputs } from '../../../../utils/constants';
export const cardStyle = {
    py: 3,
    px: 2,
    width: 'auto',
    display: 'flex',
    height: '300px',
    borderRadius: 'md',
    flexDirection: 'column',
    boxShadow: 'rgba(50, 71, 92, 0.1) 0px 2px 10px 0px',
};

interface TopChartProp {
    height?: number;
    year: number;
    setYear: React.Dispatch<React.SetStateAction<number>>;
}

const TopChart: FC<TopChartProp> = ({ height, year, setYear }) => {

    const { user } = useUserStore();
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data: ticketClosedToday, error } = useGetTicketsClosedToday();

    const isSmallScreen = useScreenWidth();

    useEffect(() => {
        if (error) ToastMessage.Failed(error.message);
    }, [error]);

    const upCardStyle = {
        ...cardStyle,
        height: height ? `${height}px` : '300px',
        background: darkMode ? darkModeBackgroud : 'white',
    }

    const currentYear = new Date().getFullYear();
    const handleChange = (e: SelectChangeEvent<unknown>) => setYear(e.target.value as number);

    return <Sheet
        sx={upCardStyle}
    >
        <div className='d-flex flex-row justify-content-between position-relative'>
            <div className='d-flex flex-column align-items-center'>
                <div className='w-100'>
                    <h4 style={{ color: '#696CFF' }}>{user?.fullname}</h4>
                </div>
                <div className='mt-2 mb-2'>
                    <p className='p-text-dashboard' style={darkMode ? { color: 'white' } : {}}>
                        {language['HomeParagraph1'].replace(`{}`, `${ticketClosedToday ?? 0}`)}
                    </p>
                </div>
                <div className='d-flex align-items-center w-100 mt-4'>
                    <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                            <InputLabel
                                id="year-select"
                                sx={{ color: darkMode ? 'white' : 'inherit' }}
                            >
                                {language['Year']}
                            </InputLabel>
                            <Select
                                labelId="year-select"
                                id="year-select"
                                label={language['Year']}
                                sx={{
                                    color: darkMode ? 'white' : 'inherit',
                                    '.MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'white' : '#C4C4C4',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'white' : '#C4C4C4',
                                    },
                                    '.MuiSvgIcon-root': {
                                        color: darkMode ? 'white' : 'inherit',
                                    }
                                }}
                                value={year}
                                onChange={handleChange}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: darkMode ? darkModeBackgroudInputs : 'white',
                                            color: darkMode ? 'white' : 'black',
                                        },
                                    },
                                }}
                            >
                                {[currentYear, currentYear - 1, currentYear - 2].map(item => (
                                    <MenuItem
                                        key={item}
                                        value={item}
                                        sx={{ color: darkMode ? 'black' : 'inherit', }}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
            </div>
        </div>
        <div className='position-absolute' style={{ bottom: 0, right: 10 }}>
            <img
                src={deskImage}
                alt="Sample Image"
                style={{ width: isSmallScreen ? '200px' : '350px', height: isSmallScreen ? '130px' : '220px' }}
            />
        </div>
    </Sheet>
}
export default TopChart;